import React, { useEffect, useState } from "react";
import SidebarBlog from "../components/blog/sidebar-blog";
import BlogList from "../components/blog/blog-list";
import Layout from "../components/layout/layout";
import blogService from "../services/blogService";

const BlogListPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const data = await blogService.getAllBlogs();
        setBlogs(data);
        setFilteredBlogs(data); // Initially, show all blogs
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  // Handle search query changes
  useEffect(() => {
    const filtered = blogs.filter((blog) =>
      `${blog.name}`.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredBlogs(filtered);
  }, [searchQuery, blogs]);

  return (
    <Layout>
      <div className="content">
        <div className="container">
          <div className="row">
            <BlogList blogs={filteredBlogs} loading={loading} error={error} />
            <SidebarBlog setSearchQuery={setSearchQuery} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default BlogListPage;
